import {
  NotFoundException,
  patchAddRoleToUser,
  patchChangeUserId,
  patchChangeUserType,
  patchRemoveRoleFromUser,
  Role,
  User,
  UserType,
} from '@nemuru-eng/js-api-client';

import { useRequest } from '@/hooks/requests/useRequest';

export const useChangeUserById = () => {
  const { request, loading } = useRequest();

  const changeUserToAgent = async (newUserId: string, currentUser: User) => {
    if (currentUser.userType !== UserType.AGENT) {
      await request(patchAddRoleToUser, { id: currentUser.id, role: Role.ROLE_AGENT });
      await request(patchChangeUserType, { id: currentUser.id, userType: UserType.AGENT });
      await request(patchRemoveRoleFromUser, { id: currentUser.id, role: currentUser.roles[0] });
    }
    await request(patchChangeUserId, { id: currentUser.id, userId: newUserId });
  };

  const changeUserToChannel = async (newUserId: string, currentUser: User) => {
    if (currentUser.userType !== UserType.CHANNEL) {
      await request(patchAddRoleToUser, { id: currentUser.id, role: Role.ROLE_CHANNEL });
      await request(patchChangeUserType, { id: currentUser.id, userType: UserType.CHANNEL });
      await request(patchRemoveRoleFromUser, { id: currentUser.id, role: currentUser.roles[0] });
    }
    await request(patchChangeUserId, { id: currentUser.id, userId: newUserId });
  };

  const changeUserToMerchant = async (newUserId: string, currentUser: User) => {
    if (currentUser.userType !== UserType.MERCHANT) {
      await request(patchAddRoleToUser, { id: currentUser.id, role: Role.ROLE_MERCHANT });
      await request(patchChangeUserType, { id: currentUser.id, userType: UserType.MERCHANT });
      await request(patchRemoveRoleFromUser, { id: currentUser.id, role: currentUser.roles[0] });
    }
    await request(patchChangeUserId, { id: currentUser.id, userId: newUserId });
  };

  const changeUserById = async (newUserId: string, currentUser: User): Promise<void> => {
    try {
      await changeUserToAgent(newUserId, currentUser);
      return;
    } catch (err) {
      if (err instanceof NotFoundException) {
        try {
          await changeUserToChannel(newUserId, currentUser);
          return;
        } catch (err) {
          if (err instanceof NotFoundException) {
            await changeUserToMerchant(newUserId, currentUser);
            return;
          }
          throw err;
        }
      }
      throw err;
    }
  };

  return { changeUserById, loading };
};
